// // src/app/components/form-builder/hooks/useDragDrop.ts

// import { useCallback, useEffect, useRef, useState } from 'react';
// import { FormField } from '../types';

// export function useDragDrop(
//   fields: FormField[],
//   onReorder: (updater: FormField[] | ((prevFields: FormField[]) => FormField[])) => void,
//   onAddField?: (type: string, index: number) => void
// ) {
//   const draggingIdx = useRef<number | null>(null);
//   const [overIdx, setOverIdx] = useState<number | null>(null);

//   const onDragStart = useCallback((i: number) => (e: React.DragEvent) => {
//     draggingIdx.current = i;
//     e.dataTransfer.effectAllowed = 'move';
//     e.dataTransfer.setData('application/x-dragged-index', i.toString());
//   }, []);

//   const onPaletteDragStart = useCallback((type: string) => (e: React.DragEvent) => {
//     e.dataTransfer.setData('application/x-form-builder-field', type);
//     e.dataTransfer.effectAllowed = 'copy';
//   }, []);

//   const onDragOver = useCallback((i: number) => (e: React.DragEvent) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.dataTransfer.types.includes('application/x-form-builder-field')) {
//       e.dataTransfer.dropEffect = 'copy';
//     } else {
//       e.dataTransfer.dropEffect = 'move';
//     }
//     setOverIdx(i);
//   }, []);

//   const onCanvasDragOver = useCallback((e: React.DragEvent) => {
//     e.preventDefault();
//     if (e.dataTransfer.types.includes('application/x-form-builder-field')) {
//       e.dataTransfer.dropEffect = 'copy';
//     }
//     setOverIdx(fields.length);
//   }, [fields.length]);

//   const onDrop = useCallback((i: number) => (e: React.DragEvent) => {
//     e.preventDefault();
//     e.stopPropagation(); // prevent canvas drop from firing if dropped on field

//     const newFieldType = e.dataTransfer.getData('application/x-form-builder-field');
//     if (newFieldType && onAddField) {
//       onAddField(newFieldType, i);
//       setOverIdx(null);
//       return;
//     }

//     const draggedIdxStr = e.dataTransfer.getData('application/x-dragged-index');
//     const from = draggedIdxStr ? parseInt(draggedIdxStr, 10) : draggingIdx.current;

//     if (from === null || isNaN(from)) {
//       setOverIdx(null);
//       return;
//     }

//     // 1. Calculate adjusted drop index (account for shift after removal)
//     let adjustedDropIdx = i;
//     if (i > from) {
//       adjustedDropIdx = i - 1;
//     }

//     // 4. Guard: if dropping in the same place, do nothing
//     if (from === adjustedDropIdx) {
//       draggingIdx.current = null;
//       setOverIdx(null);
//       return;
//     }

//     onReorder((prevFields) => {
//       console.log(`[DragDrop] BEFORE splice length: ${prevFields.length}`);
//       const next = [...prevFields];

//       // 2. Remove from original position first
//       const [moved] = next.splice(from, 1);
//       if (!moved) return prevFields; // Guard if index was invalid

//       // 5. Defensive check: prevent duplicate _id in resulting array
//       const existingIdx = next.findIndex(f => f._id === moved._id);
//       if (existingIdx !== -1) {
//         console.warn(`[DragDrop] Defensive guard: Item _id ${moved._id} already exists at index ${existingIdx}! Deduping.`);
//         next.splice(existingIdx, 1);
//       }

//       // 3. Insert at adjusted position
//       next.splice(adjustedDropIdx, 0, moved);
//       console.log(`[DragDrop] AFTER splice length: ${next.length}`);

//       return next.map((f, idx) => ({ ...f, sort_order: idx }));
//     });

//     // 3. Reset state fully
//     draggingIdx.current = null;
//     setOverIdx(null);
//   }, [onReorder, onAddField]);

//   const onCanvasDrop = useCallback((e: React.DragEvent) => {
//     e.preventDefault();
//     const newFieldType = e.dataTransfer.getData('application/x-form-builder-field');
//     if (newFieldType && onAddField) {
//       // Add to end of list
//       onAddField(newFieldType, fields.length);
//     }
//     setOverIdx(null);
//     draggingIdx.current = null;
//   }, [fields.length, onAddField]);

//   const onDragEnd = useCallback(() => {
//     draggingIdx.current = null;
//     setOverIdx(null);
//   }, []);

//   return { onDragStart, onPaletteDragStart, onDragOver, onCanvasDragOver, onDrop, onCanvasDrop, onDragEnd, overIdx };
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // src/app/components/form-builder/hooks/useSignaturePad.ts


// export function useSignaturePad(canvasRef: React.RefObject<HTMLCanvasElement>) {
//   const isDrawing = useRef(false);
//   const lastPos   = useRef({ x: 0, y: 0 });

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;

//     const resize = () => {
//       const data = canvas.toDataURL();
//       canvas.width  = canvas.offsetWidth;
//       canvas.height = canvas.offsetHeight;
//       const ctx = canvas.getContext('2d');
//       if (!ctx) return;
//       ctx.strokeStyle = '#1a1a1a';
//       ctx.lineWidth   = 1.5;
//       ctx.lineCap     = 'round';
//       ctx.lineJoin    = 'round';
//       const img = new Image();
//       img.onload = () => ctx.drawImage(img, 0, 0);
//       img.src    = data;
//     };

//     resize();
//     const ro = new ResizeObserver(resize);
//     ro.observe(canvas);

//     const getPos = (e: MouseEvent | TouchEvent) => {
//       const rect = canvas.getBoundingClientRect();
//       const pt   = 'touches' in e ? e.touches[0] : e;
//       return { x: pt.clientX - rect.left, y: pt.clientY - rect.top };
//     };

//     const ctx = canvas.getContext('2d')!;

//     const start = (e: MouseEvent | TouchEvent) => {
//       e.preventDefault();
//       isDrawing.current = true;
//       lastPos.current   = getPos(e);
//     };
//     const draw = (e: MouseEvent | TouchEvent) => {
//       if (!isDrawing.current) return;
//       e.preventDefault();
//       const pos = getPos(e);
//       ctx.beginPath();
//       ctx.moveTo(lastPos.current.x, lastPos.current.y);
//       ctx.lineTo(pos.x, pos.y);
//       ctx.stroke();
//       lastPos.current = pos;
//     };
//     const end = () => { isDrawing.current = false; };

//     canvas.addEventListener('mousedown',  start);
//     canvas.addEventListener('mousemove',  draw);
//     canvas.addEventListener('mouseup',    end);
//     canvas.addEventListener('mouseleave', end);
//     canvas.addEventListener('touchstart', start, { passive: false });
//     canvas.addEventListener('touchmove',  draw,  { passive: false });
//     canvas.addEventListener('touchend',   end);

//     return () => {
//       ro.disconnect();
//       canvas.removeEventListener('mousedown',  start);
//       canvas.removeEventListener('mousemove',  draw);
//       canvas.removeEventListener('mouseup',    end);
//       canvas.removeEventListener('mouseleave', end);
//       canvas.removeEventListener('touchstart', start);
//       canvas.removeEventListener('touchmove',  draw);
//       canvas.removeEventListener('touchend',   end);
//     };
//   }, [canvasRef]);

//   const clear = () => {
//     const canvas = canvasRef.current;
//     if (!canvas) return;
//     const ctx = canvas.getContext('2d');
//     ctx?.clearRect(0, 0, canvas.width, canvas.height);
//   };

//   const toDataURL = () => canvasRef.current?.toDataURL('image/png') ?? '';

//   return { clear, toDataURL };
// }
// src/app/components/form-builder/hooks/useDragDrop.ts

import { useCallback, useEffect, useRef, useState } from 'react';
import { FormField } from '../types';

export function useDragDrop(
  fields: FormField[],
  onReorder: (updater: FormField[] | ((prevFields: FormField[]) => FormField[])) => void,
  onAddField?: (type: string, index: number) => void
) {
  const draggingIdx = useRef<number | null>(null);
  const [overIdx, setOverIdx] = useState<number | null>(null);

  // ✅ New: Track if a drop is in progress to prevent duplicates
  const isProcessingDrop = useRef<boolean>(false);
  // ✅ New: Track the source of drag (palette vs canvas)
  const dragSource = useRef<'palette' | 'canvas' | null>(null);
  // ✅ New: Debounce timer for resetting state
  const resetTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // ── Palette Drag Start ──────────────────────────────────────────────────────
  const onPaletteDragStart = useCallback((type: string) => (e: React.DragEvent) => {
    // Clear any pending reset
    if (resetTimeoutRef.current) {
      clearTimeout(resetTimeoutRef.current);
      resetTimeoutRef.current = null;
    }

    dragSource.current = 'palette';
    isProcessingDrop.current = false;
    e.dataTransfer.setData('application/x-form-builder-field', type);
    e.dataTransfer.effectAllowed = 'copy';

    // Store in a separate ref for quick access
    (e.target as HTMLElement)?.setAttribute('data-drag-type', 'palette');
  }, []);

  // ── Canvas Drag Start ──────────────────────────────────────────────────────
  const onDragStart = useCallback((i: number) => (e: React.DragEvent) => {
    // Clear any pending reset
    if (resetTimeoutRef.current) {
      clearTimeout(resetTimeoutRef.current);
      resetTimeoutRef.current = null;
    }

    dragSource.current = 'canvas';
    isProcessingDrop.current = false;
    draggingIdx.current = i;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('application/x-dragged-index', i.toString());

    // Also set a flag to identify canvas drag
    (e.target as HTMLElement)?.setAttribute('data-drag-type', 'canvas');
  }, []);

  // ── Drag Over ──────────────────────────────────────────────────────────────
  const onDragOver = useCallback((i: number) => (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Don't update overIdx if processing a drop
    if (isProcessingDrop.current) return;

    if (e.dataTransfer.types.includes('application/x-form-builder-field')) {
      e.dataTransfer.dropEffect = 'copy';
    } else {
      e.dataTransfer.dropEffect = 'move';
    }
    setOverIdx(i);
  }, []);

  const onCanvasDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();

    // Don't update if processing a drop
    if (isProcessingDrop.current) return;

    if (e.dataTransfer.types.includes('application/x-form-builder-field')) {
      e.dataTransfer.dropEffect = 'copy';
    }
    setOverIdx(fields.length);
  }, [fields.length]);

  // ── Drop Handler ────────────────────────────────────────────────────────────
  const onDrop = useCallback((i: number) => (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // ✅ Prevent multiple simultaneous drops
    if (isProcessingDrop.current) {
      console.log('[DragDrop] Drop already in progress, ignoring.');
      return;
    }

    // ✅ Check if this is a palette drop
    const newFieldType = e.dataTransfer.getData('application/x-form-builder-field');
    if (newFieldType && onAddField) {
      // Mark as processing
      isProcessingDrop.current = true;

      // Add the field
      onAddField(newFieldType, i);

      // Reset after a short delay to prevent double execution
      resetTimeoutRef.current = setTimeout(() => {
        isProcessingDrop.current = false;
        dragSource.current = null;
        setOverIdx(null);
        resetTimeoutRef.current = null;
      }, 150);

      return;
    }

    // ✅ Canvas reorder drop
    const draggedIdxStr = e.dataTransfer.getData('application/x-dragged-index');
    const from = draggedIdxStr ? parseInt(draggedIdxStr, 10) : draggingIdx.current;

    if (from === null || isNaN(from) || from === i) {
      setOverIdx(null);
      return;
    }

    // Mark as processing
    isProcessingDrop.current = true;

    // Calculate adjusted drop index
    let adjustedDropIdx = i;
    if (i > from) {
      adjustedDropIdx = i - 1;
    }

    // Guard: if dropping in the same place, do nothing
    if (from === adjustedDropIdx) {
      isProcessingDrop.current = false;
      draggingIdx.current = null;
      setOverIdx(null);
      return;
    }

    // Perform reorder
    onReorder((prevFields) => {
      const next = [...prevFields];

      // Remove from original position
      const [moved] = next.splice(from, 1);
      if (!moved) return prevFields;

      // Defensive check: prevent duplicate _id
      const existingIdx = next.findIndex(f => f._id === moved._id);
      if (existingIdx !== -1) {
        console.warn(`[DragDrop] Duplicate _id ${moved._id} found, deduping.`);
        next.splice(existingIdx, 1);
      }

      // Insert at adjusted position
      next.splice(adjustedDropIdx, 0, moved);

      return next.map((f, idx) => ({ ...f, sort_order: idx }));
    });

    // Reset after delay
    resetTimeoutRef.current = setTimeout(() => {
      draggingIdx.current = null;
      setOverIdx(null);
      isProcessingDrop.current = false;
      dragSource.current = null;
      resetTimeoutRef.current = null;
    }, 150);

  }, [onReorder, onAddField]);

  // ── Canvas Drop ─────────────────────────────────────────────────────────────
  const onCanvasDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();

    // ✅ Prevent multiple simultaneous drops
    if (isProcessingDrop.current) {
      console.log('[DragDrop] Canvas drop already in progress, ignoring.');
      return;
    }

    const newFieldType = e.dataTransfer.getData('application/x-form-builder-field');
    if (newFieldType && onAddField) {
      // Mark as processing
      isProcessingDrop.current = true;

      // Add to end of list
      onAddField(newFieldType, fields.length);

      // Reset after delay
      resetTimeoutRef.current = setTimeout(() => {
        isProcessingDrop.current = false;
        dragSource.current = null;
        setOverIdx(null);
        resetTimeoutRef.current = null;
      }, 150);
    }

  }, [fields.length, onAddField]);

  // ── Drag End ────────────────────────────────────────────────────────────────
  const onDragEnd = useCallback(() => {
    // Don't reset immediately if a drop is in progress
    if (isProcessingDrop.current) {
      // Schedule reset after current drop completes
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
      }
      resetTimeoutRef.current = setTimeout(() => {
        draggingIdx.current = null;
        setOverIdx(null);
        isProcessingDrop.current = false;
        dragSource.current = null;
        resetTimeoutRef.current = null;
      }, 200);
      return;
    }

    draggingIdx.current = null;
    setOverIdx(null);
    dragSource.current = null;
  }, []);

  // ── Cleanup on unmount ─────────────────────────────────────────────────────
  useEffect(() => {
    return () => {
      if (resetTimeoutRef.current) {
        clearTimeout(resetTimeoutRef.current);
        resetTimeoutRef.current = null;
      }
    };
  }, []);

  return {
    onDragStart,
    onPaletteDragStart,
    onDragOver,
    onCanvasDragOver,
    onDrop,
    onCanvasDrop,
    onDragEnd,
    overIdx,
  };
}